module.exports = __webpack_public_path__ + "img/wave_mobile_nav.e5605384.png";